// Utils
import localStorageService from '../../../../../utils/services/localStorage/localStorage';

// Constants
const LOCALE_SUGGESTION_SUGGESTED_KEY = 'milanote.locale.suggested';
const LOCALE_SUGGESTION_PERMANENTLY_DISMISSED_KEY = 'milanote.locale.dismissed_permanently';

export const getHasLocaleSuggestionBeenSuggested = (): boolean =>
    !!localStorageService.getItem(LOCALE_SUGGESTION_SUGGESTED_KEY);

export const getHasLocaleSuggestionBeenPermanentlyDismissed = (): boolean =>
    !!localStorageService.getItem(LOCALE_SUGGESTION_PERMANENTLY_DISMISSED_KEY);

export const setLocaleSuggestionAsSuggested = (): void =>
    localStorageService.setItem(LOCALE_SUGGESTION_SUGGESTED_KEY, 'true') as void;

export const setLocaleSuggestionAsPermanentlyDismissed = (): void =>
    localStorageService.setItem(LOCALE_SUGGESTION_PERMANENTLY_DISMISSED_KEY, 'true') as void;
